import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, take } from 'rxjs/operators';
import { AppLanguages } from 'src/app/core/models/models';
import { AuthFactoryService } from '../authFactory.service';
import { IAuthStatusToken } from '../models/authStatusToken.model';
import { PlatformIntegration } from 'src/app/integrations/models/platform-integration.enum';
import { environment } from 'src/environments/environment';
import { ENVIRONMENT, PAGETYPE } from 'src/app/core/enums/enums';
import { LayoutService } from 'src/app/layout/services/layout.service';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';

function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authFactoryService = inject(AuthFactoryService);
  const translateService = inject(TranslateService);
  const layoutService = inject(LayoutService);

  return authFactoryService.getSesionStatusToken().pipe(
    map((status) => {
      const parsedStatusToken: IAuthStatusToken = {
        isAuthenticated: status[0],
        accessToken: status[1]
      };

      if (parsedStatusToken.isAuthenticated) {
        layoutService
          .getBookingCredentialsState()
          .pipe(take(1))
          .subscribe((credentials) => {
            if (
              !credentials?.data?.username &&
              !window.location.href.includes(PAGETYPE.dashboard)
            ) {
              layoutService.requireBookingCredentials();
            }
          });

        authFactoryService.dispatchSaveToken(parsedStatusToken.accessToken);
        let lang = AppLanguages.english;

        if (environment.name !== ENVIRONMENT.develop) {
          switch (authFactoryService.getCurrentPlatform()) {
            case PlatformIntegration.salesforce:
              lang = AppLanguages.spanishMexican;
              break;

            case PlatformIntegration.default:
              lang = parseJwt(parsedStatusToken.accessToken)?.client_lang || AppLanguages.spanish;
              break;
          }
        }

        authFactoryService.dispatchSaveLang(lang);
        translateService.use(lang);
        return true;
      }
      return router.parseUrl('/unauthorized');
    })
  );
};
